import React from "react";
import Navbar from "../navbar/navbar-desktop.tsx";
import Footer from "../footer/footer.tsx";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { FaChevronRight } from "react-icons/fa6";

function Svatby() {
  return (
    <div className="w-full overflow-x-hidden font-['Libre_Baskerville']">

      <Helmet>
        <title>Svatby | Hospůdka pod Rablinů</title>
      </Helmet>

      <Navbar />

      {/* ======================================================
         MOBILE
      ====================================================== */}
      <div className="block lg:hidden bg-[#F5E7CC]">

        {/* HERO */}
        <div className="mt-20 px-2">
          <img
            src="./img/svatby.jpg"
            className="w-full h-56 object-cover rounded-md"
            alt="Svatební prostor Hospůdky pod Rablinů"
          />

          <div className="flex gap-2 mt-2">
            <img
              src="./img/svatby-venku-1.jpg"
              className="w-1/2 h-40 object-cover rounded-md"
              alt="Venkovní svatební obřad"
            />
            <img
              src="./img/svatba-rablina-exterior-1.jpg"
              className="w-1/2 h-40 object-cover rounded-md"
              alt="Svatební exteriér Hospůdky pod Rablinů"
            />
          </div>
        </div>

        {/* TEXT */}
        <div className="px-6 mt-10">
          <p className="text-lg">Hospůdka pod Rablinů</p>
          <p className="text-2xl font-bold mt-1">SVATEBNÍ UDÁLOSTI</p>

          <p className="text-sm mt-6 leading-relaxed">
            Naše hospůdka je útulná dřevěná chalupa s rustikálním interiérem.
            Prostorná zahrada s pódiem a terasou je ideální pro letní svatební obřady.
            <br /><br />
            Kapacita vnitřních prostor je až 100 osob a zahradní plochy pojmou dalších 200 hostů.
          </p>

          <Link to="/rezervace">
            <button className="mt-8 px-6 py-3 bg-[#60260F] text-white rounded-md font-bold">
              Rezervace
            </button>
          </Link>
        </div>

        {/* === MOBILNÍ SEKCE: OBRÁZEK + NADPIS + TEXT (CHYBĚLA) === */}
        <div className="mt-16 space-y-16 px-6">
          {[
            {
              img: "./img/svatby/svatby-17.jpg",
              title: "Venkovní obřad",
              text: "Naše hospůdka je útulná dřevěná chalupa s rustikálně laděným interiérem. Prostorná zahrada s pódiem a terasou je ideální pro letní svatební obřady.",
            },
            {
              img: "./img/svatby/svatby-24.jpg",
              title: "Prostor pro svatební hostiny",
              text: "Prostor pro svatební hostiny s výhledem na valašskou přírodu. Užijte si domácí kuchyni a pohodovou atmosféru.",
            },
            {
              img: "./img/grillovani.webp",
              title: "Grillování na místě",
              text: "Dejte svatbě osobitost – grilujeme jen to nejlepší přímo pro vás a vaše hosty.",
            },
          ].map((item, i) => (
            <div key={i}>
              <img
                src={item.img}
                className="w-full h-52 object-cover rounded-lg"
                alt={item.title}
              />
              <h3 className="mt-5 text-lg font-bold text-left">
                {item.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-left">
                {item.text}
              </p>
            </div>
          ))}
        </div>

        {/* DOPRAVA / ODVOZ */}
        <div className="px-6 mt-20">
          <div className="bg-white rounded-xl overflow-hidden shadow-sm border border-[#e8d6b8]">
            <img
              src="https://www.autanet.cz/img-vehicle/226/75915/toyota-proace-verso-20d-l2-business-comfort-25297538-4.jpg"
              className="w-full h-48 object-cover"
              alt="Odvoz svatebčanů z Hospůdky pod Rablinů"
            />
            <div className="p-5">
              <p className="text-xs uppercase tracking-[0.25em] text-[#8c5a3c]">
                Doprava
              </p>
              <h3 className="text-lg font-bold text-[#60260F] mt-2">
                Postaráme se i o cestu domů
              </h3>
              <p className="text-sm leading-relaxed mt-3">
                Ke svatbě umíme zajistit svoz i odvoz svatebčanů, ať nikdo
                z hostů neřeší, kdo bude řídit. Trasu i čas odjezdů
                přizpůsobíme programu vašeho dne.
              </p>
              <p className="text-sm leading-relaxed mt-3 font-bold text-[#60260F]">
                Dopravu je nutné domluvit předem s personálem, případně přímo
                s majitelem – kapacita je omezená.
              </p>
            </div>
          </div>
        </div>

        {/* ODKAZ NA FOTOGALERII */}
        <div className="mt-24 mb-16 text-center">
          <Link to="/fotogalerie-exterier" className="underline text-base">
            Více fotografií zde
          </Link>
        </div>

        <Footer />
      </div>

      {/* ======================================================
         DESKTOP
      ====================================================== */}
      <div className="hidden lg:block bg-[#F5E7CC]">

        {/* NADPIS */}
        <section className="bg-white py-24 text-center">
          <h1 className="text-4xl tracking-wide text-[#60260F]">
            PROSTORY PRO KONÁNÍ SVATEB
          </h1>
        </section>

        {/* 3 OBRÁZKY */}
        <section className="max-w-7xl mx-auto px-10 py-20">
          <div className="grid grid-cols-3 gap-6">
            {[
              "./img/svatby.jpg",
              "./img/svatby-venku-1.jpg",
              "./img/svatba-rablina-exterior-1.jpg",
            ].map((img, i) => (
              <div key={i} className="aspect-[4/3]">
                <img
                  src={img}
                  className="w-full h-full object-cover rounded-xl"
                  alt="Fotografie svatebního prostoru"
                />
              </div>
            ))}
          </div>
        </section>

        {/* TEXT */}
        <section className="max-w-4xl mx-auto text-center py-5 mb-20 px-6">
          <p className="text-2xl font-semibold text-[#60260F]">
            Naše hospůdka je útulná dřevěná chalupa s rustikálním interiérem.
          </p>
          <p className="mt-6 text-base">
            Kapacita vnitřních prostor je až 100 osob a zahradní plochy pojmou dalších 200 hostů.
          </p>
        </section>

        {/* CTA */}
        <section className="bg-[#FBF1DA] py-24 text-center border-t border-b border-[#1f3a8a]">
          <h2 className="text-3xl text-[#60260F]">Zamluvte si termín</h2>
          <p className="mt-2 mb-12">Na pár kliknutí</p>

          <div className="flex justify-center gap-10">
            <Link to="/rezervace-ubytovani">
              <button className="px-12 py-4 border border-[#60260F] rounded-xl">
                Rezervace ubytování
              </button>
            </Link>
            <Link to="/rezervace-akce">
              <button className="px-12 py-4 border border-[#60260F] rounded-xl">
                Rezervace akcí
              </button>
            </Link>
          </div>
        </section>

        {/* SPODNÍ GALERIE + TEXTY */}
        <section className="max-w-7xl mx-auto px-10 py-20">
          <div className="grid grid-cols-3 gap-6">
            {[
              {
                img: "./img/svatby/svatby-17.jpg",
                title: "Venkovní obřad",
                text: "Prostorná zahrada a romantická atmosféra pro váš velký den.",
              },
              {
                img: "./img/svatby/svatby-24.jpg",
                title: "Svatební hostiny",
                text: "Útulné prostředí, domácí kuchyně a pohodová atmosféra.",
              },
              {
                img: "./img/grillovani.webp",
                title: "Grillování",
                text: "Osobitý gastronomický zážitek přímo pro vás.",
              },
            ].map((item, i) => (
              <div key={i}>
                <div className="aspect-[4/3]">
                  <img
                    src={item.img}
                    className="w-full h-full object-cover rounded-xl"
                    alt={item.title}
                  />
                </div>
                <h3 className="mt-4 text-lg font-semibold text-left">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-left leading-relaxed">
                  {item.text}
                </p>
              </div>
            ))}
          </div>

          <div className="text-center mt-16">
            <Link
              to="/fotogalerie-exterier"
              className="inline-flex items-center gap-2 text-lg"
            >
              Více z fotografií <FaChevronRight />
            </Link>
          </div>
        </section>

        {/* DOPRAVA / ODVOZ */}
        <section className="max-w-7xl mx-auto px-10 pb-24">
          <div className="bg-white rounded-2xl overflow-hidden border border-[#e0cbaa] shadow-[0_10px_30px_-15px_rgba(96,38,15,0.35)] grid grid-cols-1 xl:grid-cols-2">
            <div className="aspect-[4/3] xl:aspect-auto xl:h-full">
              <img
                src="https://www.autanet.cz/img-vehicle/226/75915/toyota-proace-verso-20d-l2-business-comfort-25297538-4.jpg"
                className="w-full h-full object-cover"
                alt="Odvoz svatebčanů z Hospůdky pod Rablinů"
              />
            </div>
            <div className="p-10 xl:p-14 flex flex-col justify-center">
              <p className="text-xs uppercase tracking-[0.3em] text-[#8c5a3c]">
                Doprava
              </p>
              <h2 className="text-2xl text-[#60260F] mt-3">
                Postaráme se i o cestu domů
              </h2>
              <p className="mt-6 leading-relaxed">
                Ke svatbě umíme zajistit svoz i odvoz svatebčanů, ať nikdo
                z hostů neřeší, kdo bude řídit. Trasu i čas odjezdů
                přizpůsobíme programu vašeho dne.
              </p>
              <p className="mt-4 leading-relaxed font-semibold text-[#60260F]">
                Dopravu je nutné domluvit předem s personálem, případně přímo
                s majitelem – kapacita je omezená.
              </p>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </div>
  );
}

export default Svatby;
